import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ShieldCheck } from "lucide-react";
import { RoleEditor } from "@/components/RoleEditor";

/**
 * AdminUserRolesPage — /admin/personnes/:userId/roles
 *
 * V10 Hotfix Pilote : la page réutilise désormais le composant partagé
 * `RoleEditor` (idem Modération). Un seul mécanisme, un seul endpoint.
 */
export default function AdminUserRolesPage() {
  const { userId } = useParams();
  const nav = useNavigate();

  return (
    <div className="max-w-3xl mx-auto p-4 md:p-6 space-y-4" data-testid="admin-user-roles-page">
      <Button variant="ghost" size="sm" onClick={() => nav(-1)} data-testid="admin-user-roles-back">
        <ChevronLeft className="h-4 w-4 mr-1" />
        Retour
      </Button>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <ShieldCheck className="h-5 w-5 text-[hsl(var(--aito-lagoon))]" />
            Rôles du profil
          </CardTitle>
          <p className="text-xs text-muted-foreground">
            Multi-rôle autorisé (Athlete + Coach + Officiel + Bénévole). Les rôles staff (admin, copf)
            ne sont pas modifiables ici — utilisez la page COPF Roles.
          </p>
        </CardHeader>
        <CardContent>
          <RoleEditor userId={userId} autoFocus />
        </CardContent>
      </Card>
    </div>
  );
}
